import { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from "../../../context/AuthContext";
import AlertMessage from "../../include/AlertMessage";
import ConfirmationPopup from "../../include/ConfirmationPopup"; // ⬅️ Import new popup
import Pagination from "../../Pagination";

var _ = require('lodash');

function Coursebookings() {
    const { role, user } = useAuth(); // Get user role from context
    const [allBookings, setallBookings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const token = sessionStorage.getItem('JWT_TOKEN');
    const { cid } = useParams();
    const [alert, setAlert] = useState({ type: "", message: "" });
    const [showPopup, setShowPopup] = useState(false); // popup state
    const [deleteId, setDeleteId] = useState(null);
    const [deleting, setDeleting] = useState(false);
    const [userNames, setUserNames] = useState({});

    const [totalPages, setTotalPages] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [searchParams, setSearchParams] = useSearchParams();
    const currentPage = Number(searchParams.get("page")) || 1;
    const LIMIT = 10;


    const fetchBookings = async (page = currentPage) => {
        try {
            setLoading(true);

            const response = await axios.get(`${process.env.REACT_APP_API_URL}/coursebookings/${cid}`, {
                params: {
                    page,
                    limit: LIMIT
                },
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token // Replace with your token
                }
            });

            const data = await response.data;
            if (Array.isArray(data.data) && data.data.length > 0 && Array.isArray(data.data)) {
                const finaldata = data.data;
                setallBookings(finaldata);
                fetchUserNames(finaldata);

                setTotalPages(response.data.pagination.totalPages);
                setTotalRecords(response.data.pagination.total);
            } else {
                setallBookings([]);
            }
        } catch (err) {
            const apierror = _.get(err, ['response', 'data', 'error', 'message'], "Something went wrong");
            setAlert({ type: "error", message: apierror });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        document.documentElement.className = "";

        fetchBookings(currentPage);
    }, [currentPage]);

    const handleDelete = async (id) => {
        if (!deleteId) return;
        try {
            setLoading(true);
            setDeleting(true);
            const response = await axios.delete(`${process.env.REACT_APP_API_URL}/deletecoursebooking/${deleteId}`,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + token // Replace with your token
                    }
                }
            );

            if (response.status === 200 || response.status === 201) {
                const updatedData = allBookings.filter(booking => booking.$id !== deleteId);

                setallBookings(updatedData);
                setAlert({ type: "success", message: "Holiday booking deleted successfully!" });

                // ⭐ If page becomes empty go to previous page
                if (updatedData.length === 0 && currentPage > 1) {
                    setSearchParams({
                        page: currentPage - 1
                    });
                }
            }
            //fetchBookings();
        } catch (err) {
            const apierror = _.get(err, ['response', 'data', 'error', 'message'], "Something went wrong");
            setAlert({ type: "error", message: apierror });
        } finally {
            setShowPopup(false); // close popup after action
            setDeleteId(null); // reset id
            setLoading(false); // stop loading
            setDeleting(false);
        }
    };

    const fetchUserNames = async (redemptions) => {
        try {
            let usersMap = {};

            await Promise.all(
                redemptions.map(async (item) => {
                    if (item.users) {
                        const response = await axios.get(
                            `${process.env.REACT_APP_API_URL}/fetchuserdetail/${item.users}`,
                            {
                                headers: {
                                    'Authorization': 'Bearer ' + token
                                }
                            }
                        );

                        usersMap[item.users] = response.data.data.email;
                    }
                })
            );

            setUserNames(usersMap);

        } catch (err) {
            const apierror = _.get(err, ['response', 'data', 'error', 'message'], "Something went wrong");
            setAlert({ type: "error", message: apierror });            
        } finally {
            setLoading(false);
        }
    };

    return (
        <section>
            <div className="is-title-bar">
                <div className="flex flex-col md:flex-row items-center justify-between space-y-6 md:space-y-0">
                    <ul>
                        <li><Link to="/dashboard" className='btn btn-primary'>Dashboard</Link></li>
                        <li><Link to="/courses" className='btn btn-primary'>Holidays</Link></li>
                        <li>Bookings</li>
                    </ul>
                    <Link to={`/coursebooking/add/${cid}`} className='button blue'>Add Booking</Link>
                </div>
            </div>
            <div className="section main-section">
                <div className="grid gap-6 grid-cols-1 md:grid-cols-12">
                    <div className="card">
                        <header className="card-header">
                            <p className="card-header-title">
                                <span className="icon"><i className="mdi mdi-reorder-horizontal"></i></span>
                                All Bookings
                            </p>
                        </header>
                        <div className="card-content">
                            {alert.message && (
                                <AlertMessage
                                    type={alert.type}
                                    message={alert.message}
                                    onClose={() => setAlert({ type: "", message: "" })}
                                    duration={3000}
                                />
                            )}

                            {loading ? (
                                <div className="flex justify-center items-center py-10">
                                    <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500 border-solid"></div>
                                </div>

                            ) : (
                                Array.isArray(allBookings) && allBookings.length > 0 ? (
                                    <>
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>User</th>
                                                    <th>TicketID</th>
                                                    <th>Payment Gateway</th>
                                                    <th>Payment Status</th>
                                                    <th>Created At</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {(allBookings || []).map((item, index) => (
                                                    <tr key={item.$id}>
                                                        <td data-label="user_email">{userNames[item.users] || "Loading..."}</td>
                                                        <td data-label="TicketID">{item.ticketID}</td>
                                                        <td data-label="PaymentGateway">{item.paymentGateway}</td>
                                                        <td data-label="PaymentStatus">{item.paymentStatus ? <span className="icon button small green"><i className="mdi mdi-check"></i></span> : <span className="icon button small red"><i className="mdi mdi-close"></i></span>}</td>
                                                        <td data-label={item.$createdAt?.split('T')[0]}>{item.$createdAt?.split('T')[0]}</td>
                                                        <td className="actions-cell">
                                                            <div className="buttons right nowrap">
                                                                <Link to={`/coursebooking/edit/${item.$id}?page=${currentPage}`} className='button small green' title='Edit'> <span className="icon"><i className="mdi mdi-lead-pencil"></i></span></Link>

                                                                {role === "admin" && (
                                                                    <button
                                                                        className="button small red"
                                                                        type="button"
                                                                        onClick={() => {
                                                                            if (deleting) return;
                                                                            setDeleteId(item.$id);
                                                                            setShowPopup(true);
                                                                        }}
                                                                        style={{
                                                                            cursor: deleting ? "not-allowed" : "pointer",
                                                                            opacity: deleting ? 0.5 : 1
                                                                        }}
                                                                    >
                                                                        <span className="icon"><i className="mdi mdi-trash-can"></i></span>
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>

                                        {totalPages > 1 && (
                                            <Pagination
                                                currentPage={currentPage}
                                                totalPages={totalPages}
                                                totalRecords={totalRecords}
                                                onPageChange={(page) =>
                                                    setSearchParams({
                                                        page
                                                    })
                                                }
                                            />
                                        )}
                                    </>
                                ) : (
                                    <p style={{ color: 'red', fontWeight: 'bold', textAlign: 'center' }}>No Record Found.</p>
                                )
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {/* Confirmation Popup */}
            <ConfirmationPopup
                show={showPopup}
                onConfirm={handleDelete}
                onCancel={() => {
                    if (!deleting) {
                        setShowPopup(false);
                    }
                }}
                title="Confirm Delete"
                message={
                    deleting
                        ? "Deleting event holiday booking..."
                        : "Are you sure you want to delete this holiday booking?"
                }
                deleting={deleting}
            />
        </section>
    );
};

export default Coursebookings;